import moment from 'moment-timezone'
import { InstructorHours } from '@interfaces/InstructorHours'
import { UserProfileProps } from '@interfaces/UserProfile'
import { BookedLesson } from '.'

export const updateSingleDHRemaining = (
  godMode: boolean = false,
  instructorHours: InstructorHours | undefined,
  start: moment.Moment,
  end: moment.Moment,
  remove?: boolean,
  cb: (instructorHours: InstructorHours | undefined) => void = () => {}
) => {
  const dailyHours = instructorHours?.instructorHoursInfo?.DailyHoursInfo || []
  const matchDH = dailyHours.find(
    item =>
      item.StartDateTime ===
      start
        .clone()
        .startOf('day')
        .toISOString()
  )
  const remaining = matchDH?.DailyHoursRemaining || 0
  const newHrs = end.clone().diff(start, 'h', true)
  godMode && console.log(`${matchDH?.StartDateTime} remaining: ${remaining}`)
  if (matchDH) {
    matchDH.DailyHoursRemaining = remove ? remaining + newHrs : remaining - newHrs
    godMode && console.log(`${matchDH?.StartDateTime} new hours: ${matchDH.DailyHoursRemaining}`)
    cb(instructorHours)
  }
}

export const updateDHRemaining = (
  godMode: boolean = false,
  instructorHours: InstructorHours | undefined,
  start: moment.Moment,
  end: moment.Moment,
  remove?: boolean,
  cb: (instructorHours: InstructorHours | undefined) => void = () => {}
) => {
  if (
    start.isSame(end, 'day') ||
    start
      .clone()
      .add(1, 'day')
      .startOf('day')
      .isSame(end)
  ) {
    updateSingleDHRemaining(godMode, instructorHours, start, end, remove, cb)
  } else {
    updateSingleDHRemaining(
      godMode,
      instructorHours,
      start,
      start
        .clone()
        .add(1, 'day')
        .startOf('day'),
      remove,
      cb
    )
    updateSingleDHRemaining(godMode, instructorHours, end.clone().startOf('day'), end, remove, cb)
  }
}

interface GroupedItems {
  [key: string]: BookedLesson[]
}

export const getBulkSidebarLessons = (lessons: BookedLesson[], profile: UserProfileProps) => {
  return lessons
    .sort((a, b) => new Date(a.StartTime).valueOf() - new Date(b.StartTime).valueOf())
    .reduce((acc: GroupedItems, lesson: BookedLesson) => {
      const start = moment.tz(lesson.StartTime, profile.Timezone)
      const monthAndYear = start.format('YYYY-MM')
      if (!acc[monthAndYear]) {
        acc[monthAndYear] = []
      }
      acc[monthAndYear] = [...acc[monthAndYear], lesson]
      return acc
    }, {})
}
